<template>
    <div class="nav">
        <div class="container">
            <div class="allType">
                <div class>全部分类</div>
                <ul class="jspop box">
                    <li class="a6" v-for="(val, index) in list" :key="index">
                        <div class="tx" @click="toProductList(val)">{{ val.name }}</div>
                        <div class="pop">
                            <dl v-for="(va, ind) in val.childList" :key="ind">
                                <dd class="title">
                                    <a class="menu2" @click="toProductList(va)">{{ va.name }}</a>
                                </dd>
                                <dd>
                                    <a
                                        v-for="(v, i) in va.childList"
                                        :key="i"
                                        class="ui-link"
                                        @click="toProductList(v)"
                                    >{{ v.name }}</a>
                                </dd>
                            </dl>
                        </div>
                    </li>
                </ul>
            </div>
            <router-link class="item" to="/">首页</router-link>
            <router-link class="item" to="/introduce/about_us">关于我们</router-link>
          <!--   <router-link class="item" to="/hot/2">促销产品</router-link> -->
            <router-link class="item" to="/promade">化合物定制</router-link>
            <router-link class="item" to="/proindex">索要产品目录</router-link>
            <router-link class="item" to="/score-shop">积分商城</router-link>
            <router-link class="item" to="/news-list">行业资讯</router-link>
            <router-link class="item" to="/"></router-link>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/common';

import { mapActions } from 'vuex';

export default {
    name: 'v-nav',
    data() {
        return {
            list: [],
        };
    },
    methods: {
        ...mapActions(['setBreadcrumb']),
        getList() {
            apis.getNavList().then(res => {
                this.list = res;
            });
        },
        toProductList(v) {
            this.setBreadcrumb(v.name);
            this.$router.push('/product-list/' + v.id);
        },
    },
    mounted() {
        this.getList();
    },
};
</script>

<style lang="less" scoped>
.nav {
    width: 100%;
    height: 52px;
    background: #ffffff;
    color: #282b35;
    line-height: 52px;
    text-align: center;
    .allType {
        width: 220px;
        float: left;
        height: 52px;
        cursor: pointer;
        background-color: #3c9539;
        color:#ffffff;

        /** 全部分类 hover相关样式 **/
        .hide {
            display: none;
        }

        ul {
            z-index: 99999;
            position: relative;
            width: 220px;
            min-height: 100px;
            cursor: pointer;
            margin: 0;
            padding: 0;
            list-style-type: none;
            background: rgba(60,60,60,0.8);
            padding-bottom: 10px;
            display: none;
            border: 1px solid #eeeeee;
            color: #ffffff;
            li {
                zoom: 1;
                clear: both;
                text-align: center;
                .tx {
                    line-height: 40px;
                    background-repeat: no-repeat;
                    background-position: right center;
                    height: 40px;
                    font-size: 14px;
                    a {
                        font-size: 14px;
                        transition: color 0.1s ease-out 0s;
                        color: #ffffff;
                        border-radius: 0px;
                    }
                }
                .pop {
                    position: absolute;
                    border-left: medium none;
                    padding-bottom: 10px;
                    background-color: #ffffff;
                    height: 400px;
                    overflow: auto;
                    padding-left: 30px;
                    width: 1000px;
                    padding-right: 30px;
                    display: none;
                    border-top: medium none;
                    top: 0px;
                    left: 220px;
                    box-shadow: 4px 4px 5px -1px #999999;
                    dl {
                        color: #333333;
                        zoom: 1;
                        clear: both;
                        dt {
                            padding-left: 0px;
                            width: 82px;
                            text-align: right;
                            font-weight: bold;
                            font-size: 13px;
                            float: left;
                            padding-top: 1px;
                        }
                        dd {
                            width: 800px;
                            margin-left: 12px;
                            line-height: 22px;
                            float: left;
                            padding-top: 2px;
                            text-align: left;
                            a {
                                width: initial;
                                height: 30px;
                                line-height: 35px;
                                /* background-color: #fcfcfc;*/
                                font-size: 13px;
                            }
                            a:hover {
                                color: #3c9539 !important;
                            }
                        }
                        a {
                            color: #333333;
                            margin-left: 12px;
                            margin-right: 12px;
                            line-height: 30px;
                            white-space: nowrap;
                        }
                        .title {
                            margin-right: 24px;
                            font-size: 13px;
                            font-weight: 600;
                        }
                    }
                }
            }
            li:hover {
                background: #ffffff !important;
                color: black;
                .pop {
                    display: block;
                }
            }
        }
    }


    .allType:hover ul {
        display: block;
    }

    .item {
        float: left;
        width: 125px;
        cursor: pointer;
        color: #303133;
    }
    .item:hover {
        color: #3c9539 !important;
    }
}
</style>
